<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight set">
        <!-- 实名认证 [[ -->
        <div class="account-settings" v-if="[10,20,40].includes(userInfo.authorType)">
            <div>
                <ul class="as-inf-fill-in">
                    <li class="as-fill-in-box as-personal-inf">
                        <h5 class="as-inf-tit flex">
                            <span class="ico ico-works-inf f-inlineblock-middle"></span>
                            <p class="f-inlineblock-top as-inf-tit-text">实名认证</p>
                            <template v-if="userInfo.authorType === 20">
                                <span class="mcn-icon el-icon-warning tgl-color"></span>
                                <p class="tgl-color">待审核</p>
                            </template>
                            <template v-if="userInfo.authorType === 40">
                                <span class="mcn-icon el-icon-error tgl-color"></span>
                                <p class="tgl-color">审核驳回</p>
                                <p class="tgl-color mcn-reject" v-show="userInfo.verifyResult">（驳回原因：{{userInfo.verifyResult}}）</p>
                            </template>
                        </h5>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top mcn-required">姓名</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="手机号" autocomplete="off" placeholder="请填写姓名" v-model="userInfo.realUserName" :disabled="!editMode">
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top mcn-required">身份证号</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="手机号" autocomplete="off" placeholder="请填写身份证号码" v-model="userInfo.identityCard" :disabled="!editMode">
                            </div>
                        </div>
                        <div v-if="editMode">
                            <div class="as-fill-in-con as-photo">
                                <p class="as-name f-inlineblock-top mcn-required">身份证照片</p>
                                <div class="fill-in-file">
                                    <div class="g-upload as-photo-just">
                                        <tgl-image-cloud-upload style="display: inline-block;margin-left: 0px;height: 126px" btnId='identityPic1' ref="imgUploadFile" @completed="imageUploadCompleted" :isIdCard="true" :cardType="1" :type="30" :userName="userInfo.realUserName" :userCard="userInfo.identityCard" :domHeight="127" :domWidth="207">
                                            <template #text>
                                                <div class='upload-text' style='color:#FD7E28;margin-top: 5px'>上传身份证人像面</div>
                                            </template>
                                        </tgl-image-cloud-upload>
                                    </div>
                                    <div class="g-upload as-photo-back identity-upload-box">
                                        <tgl-image-cloud-upload style="display: inline-block;margin-left: 0px;height: 126px" btnId='identityPic2' ref="imgUploadFile" @completed="imageUploadCompleted" :isIdCard="true" :cardType="2" :type="30" :userName="userInfo.realUserName" :userCard="userInfo.identityCard" :domHeight="127" :domWidth="207">
                                            <template #text>
                                                <div class='upload-text' style='color:#FD7E28;margin-top: 5px'>上传身份证国徽面</div>
                                            </template>
                                        </tgl-image-cloud-upload>
                                    </div>
                                    <div class="g-upload as-photo-hold">
                                        <tgl-image-cloud-upload style="display: inline-block;margin-left: 0px;height: 126px" btnId='identityPic3' ref="imgUploadFile" @completed="imageUploadCompleted" :isIdCard="true" :cardType="3" :type="30" :userName="userInfo.realUserName" :userCard="userInfo.identityCard" :domHeight="127" :domWidth="207">
                                            <template #text>
                                                <div class='upload-text' style='color:#FD7E28;margin-top: 5px'>上传手持身份证照片</div>
                                            </template>
                                        </tgl-image-cloud-upload>
                                    </div>
                                </div>
                            </div>
                            <div class="as-fill-in-con" style="padding-top:0">
                                <p class="as-name">照片要求：</p>
                                <ul class="as-list">
                                    <li class="as-list-con">1、身份证照片文字信息、头像信息清晰可见、无遮挡；</li>
                                    <li class="as-list-con">2、图片内容真实有效、不得涂改或后期编辑；</li>
                                    <li class="as-list-con">3、手持身份证照片请确保手臂完整露出；</li>
                                    <li class="as-list-con">4、每张照片大小不得超过1M，支持jpg、png等多种图片格式；</li>
                                </ul>
                            </div>
                        </div>
                        <div v-else>
                            <div class="as-fill-in-con as-photo">
                                <p class="as-name f-inlineblock-top mcn-required">身份证照片</p>
                                <div class="fill-in-file">
                                    <div class="f-inlineblock-top upload-photo">
                                        <img class="upload-photo-img" src="~Assets/img/pages/v4/img-1.png">
                                        <p class="up-already-upload">
                                            <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                            已上传
                                        </p>
                                    </div>
                                    <div class="f-inlineblock-top upload-photo">
                                        <img class="upload-photo-img" src="~Assets/img/pages/v4/img-3.png">
                                        <p class="up-already-upload">
                                            <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                            已上传
                                        </p>
                                    </div>
                                    <div class="f-inlineblock-top upload-photo">
                                        <img class="upload-photo-img" src="~Assets/img/pages/v4/img-2.png">
                                        <p class="up-already-upload">
                                            <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                            已上传
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </li>
                </ul>
                <div class="bottom-btn" v-show="userInfo.authorType == 10">
                    <a class="auditing_btn g-btn" href="javascript:;" @click="submitForm()">提交</a>
                </div>
                <div class="bottom-btn" v-if="userInfo.authorType == 20 || userInfo.authorType == 40">
                    <a class="auditing_btn g-btn" href="javascript:;" @click="submitForm()" v-if="editMode">提交</a>
                    <a class="auditing_btn g-btn" href="javascript:;" @click="cancelSubmit" v-if="editMode">取消</a>
                    <a class="auditing_btn g-btn" href="javascript:;" @click="reSubmit" v-if="!editMode">重新提交</a>
                </div>
            </div>
        </div>
        <!-- 实名认证 ]] -->

        <!-- 实名认证-已通过 [[ -->

        <div class="account-settings" v-if="userInfo.authorType === 30">
            <ul class="as-inf-fill-in">
                <li class="as-fill-in-box as-personal-inf">
                    <h5 class="as-inf-tit flex">
                        <span class="ico ico-business-card f-inlineblock-middle"></span>
                        <p class="f-inlineblock-top f-hide-col-1 as-inf-tit-text">实名认证</p>
                        <span class="mcn-icon el-icon-success tgl-color"></span>
                        <p class="tgl-color">审核通过</p>
                    </h5>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">姓名</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.realUserName }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con">
                        <p class="as-name f-inlineblock-top">身份证号</p>
                        <div class="f-inlineblock-top fill-in-frame">
                            <p class="asp-fill-in-con f-hide-col-1">{{ userInfo.identityCard }}</p>
                        </div>
                    </div>
                    <div class="as-fill-in-con as-photo">
                        <p class="as-name f-inlineblock-top">身份证照片</p>
                        <div class="fill-in-file">
                            <div class="f-inlineblock-top upload-photo">
                                <img class="upload-photo-img" src="~Assets/img/pages/v4/img-1.png">
                                <p class="up-already-upload">
                                    <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                    已上传
                                </p>
                            </div>
                            <div class="f-inlineblock-top upload-photo">
                                <img class="upload-photo-img" src="~Assets/img/pages/v4/img-3.png">
                                <p class="up-already-upload">
                                    <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                    已上传
                                </p>
                            </div>
                            <div class="f-inlineblock-top upload-photo">
                                <img class="upload-photo-img" src="~Assets/img/pages/v4/img-2.png">
                                <p class="up-already-upload">
                                    <span class="f-inlineblock-middle ico ico-tick-active"></span>
                                    已上传
                                </p>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- MCN认证 [[ -->
        <div class="account-settings">
            <div>
                <ul class="as-inf-fill-in">
                    <li class="as-fill-in-box as-personal-inf">
                        <h5 class="as-inf-tit flex">
                            <span class="ico ico-works-inf f-inlineblock-middle"></span>
                            <p class="f-inlineblock-top as-inf-tit-text">MCN认证</p>
                            <template v-if="mcnInfo.authorType === 0">
                                <span class="mcn-icon el-icon-warning tgl-color"></span>
                                <p class="tgl-color">待审核</p>
                            </template>
                            <template v-if="mcnInfo.authorType === 10">
                                <span class="mcn-icon el-icon-success tgl-color"></span>
                                <p class="tgl-color">审核通过</p>
                            </template>
                            <template v-if="mcnInfo.authorType === 20">
                                <span class="mcn-icon el-icon-error tgl-color"></span>
                                <p class="tgl-color">审核驳回</p>
                                <p class="tgl-color mcn-reject" v-show="mcnInfo.verifyResult">（驳回原因：{{mcnInfo.verifyResult}}）</p>
                            </template>
                        </h5>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top mcn-required">MCN名称</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="手机号" autocomplete="off" placeholder="请填写MCN名称" v-model="mcnInfo.name" :disabled="!mcnEditMode">
                            </div>
                        </div>
                        <div class="as-fill-in-con" v-if="mcnInfo.qq">
                            <p class="as-name f-inlineblock-top mcn-required">MCN QQ号</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <p class="asp-fill-in-con f-hide-col-1">{{ mcnInfo.qq }}</p>
                            </div>
                        </div>
                        <div class="as-fill-in-con as-weixin" v-else>
                            <p class="as-name f-inlineblock-top mcn-required">MCN QQ号</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <!-- 微信号出来后字体样色需变为#666 -->
                                <div class="as-weixin-btn">
                                    <a class="g-btn" href="javascript:;" @click="bindQQ">绑定QQ号</a>
                                </div>
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top mcn-required">MCN手机号</p>
                            <div class="f-inlineblock-top fill-in-frame">
                                <input class="fill-in-con-box g-input color-gray" type="text" name="手机号" autocomplete="off" placeholder="请填写MCN负责人手机号码" v-model="mcnInfo.mobile" :disabled="!mcnEditMode">
                            </div>
                        </div>
                        <div class="as-fill-in-con">
                            <p class="as-name f-inlineblock-top mcn-required" style="width:auto">MCN资质证明材料</p><br>
                            <tgl-image-cloud-upload v-if="mcnEditMode" style="display: inline-block" btnId='pic1' :isCrop="true" :maxSize="5*1024*1024" ref="imgUploadFile1" @completed="fileUploadCompleted" @deletePic="deletePic">
                                <template #text>
                                    <div class="upload-text">点击上传图片</div>
                                </template>
                            </tgl-image-cloud-upload>
                            <img v-if="!mcnEditMode && mcnInfo.credentialAttach" :src="mcnInfo.credentialAttach" alt="" class="file-img">
                            <div v-if="!mcnEditMode && !mcnInfo.credentialAttach">
                                <img src="../../../assets/img/pages/v4/mcn_pic1.png" alt="" style="width:160px;height:117px;">
                                <img src="../../../assets/img/pages/v4/mcn_pic2.png" alt="" style="width:100px;height:117px;margin-left:20px">
                            </div>
                            <div class="as-fill-in-con" style="padding-top:10px;padding-left:0" v-if="mcnEditMode">
                                <p class="as-name">照片要求：</p>
                                <ul class="as-list">
                                    <li class="as-list-con" style="color:#333">照片大小不得超过1M，支持jpg、png等多种图片格式；</li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="bottom-btn" v-if="![0,10,20].includes(mcnInfo.authorType)">
                    <a class="auditing_btn g-btn" href="javascript:;" @click="submitMcnForm">提交</a>
                </div>
                <div class="bottom-btn" v-if="[10,20].includes(mcnInfo.authorType)">
                    <a class="auditing_btn g-btn" href="javascript:;" @click="submitMcnForm" v-if="mcnEditMode">提交</a>
                    <a class="auditing_btn g-btn" href="javascript:;" @click="cancelMcnSubmit" v-if="mcnEditMode">取消</a>
                    <a class="auditing_btn g-btn" href="javascript:;" @click="mcnReSubmit" v-if="!mcnEditMode">重新提交</a>
                </div>
            </div>
        </div>
        <!-- MCN认证 ]] -->
        <bind-account-pop ref="bindAccountPop"></bind-account-pop>
    </div>
</template>

<script>
import {
    UserApplyInfo, McnUserInfo, McnUserAuth, McnRealNameAuth
} from 'Services/getData.js';
import {
    mapGetters
} from 'vuex'
import bindAccountPop from 'Components/v4/pop/bind_account_pop.vue';
export default {
    data() {
        return {
            userInfo: {
                realUserName: '',
                identityCard: '',
                attachmentIds: ''
                // authorType 20 待审核 30 已通过 40 已驳回
            },
            mcnInfo: {
                name: "",
                qq: '',
                mobile: '',
                credentialAttach: '',
                // authorType 0 待审核 10 已通过 20 已驳回
            },
            isReadAgreement: false,
            identityAttachmentIds: [],
            editMode: false,      //实名认证重新提交
            mcnEditMode: false      //mcn重新提交
        }
    },
    components: {
        bindAccountPop
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.getUserInfo();
            this.getMcnInfo()
        },
        reSubmit() {
            this.editMode = true;
            this.userInfo.realUserName = '';
            this.userInfo.identityCard = '';
            this.userInfo.attachmentIds = '';
        },
        cancelSubmit() {
            this.editMode = false;
            this.getUserInfo();
        },
        mcnReSubmit() {
            this.mcnEditMode = true;
            this.mcnInfo.name = '';
            this.mcnInfo.mobile = '';
            this.mcnInfo.credentialAttach = '';
        },
        cancelMcnSubmit() {
            this.mcnEditMode = false;
            this.getMcnInfo();
        },
        bindQQ() {
            this.$refs.bindAccountPop.toBind('qq');
        },
        submitForm() {
            if (!this.validateForm()) {
                return false;
            }
            this.saveAuthData();
        },
        submitMcnForm() {
            if (!this.validateMcnForm()) {
                return false;
            }
            this.saveMcnData();
        },
        async saveAuthData() {
            this.userInfo.attachmentIds = this.identityAttachmentIds.join(',')
            let ret = await McnRealNameAuth(this.userInfo);
            let data = ret.data;
            if (ret.status == 200 && ret.data.code == 0) {
                this.$alert('提交成功');
                this.editMode = false;
                this.getUserInfo()
            }
        },
        async saveMcnData() {
            let ret = await McnUserAuth(this.mcnInfo);
            if (ret.status == 200 && ret.data.code == 0) {
                this.$alert('提交成功');
                this.mcnEditMode = false;
                this.getMcnInfo()
            }
        },
        validateForm() {
            if (!this.userInfo.realUserName) {
                this.$alert('请输入真实姓名');
                return false;
            }
            if (/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.userInfo.identityCard) === false) {
                this.$alert("身份证输入不合法");
                return false;
            }
            if (this.identityAttachmentIds.length !== 3) {
                this.$alert("请上传身份证照片");
                return false;
            }
            return true;
        },
        validateMcnForm() {
            if (!this.mcnInfo.name) {
                this.$alert('请输入MCN名称');
                return false;
            }
            if (!this.mcnInfo.qq || !/[1-9]\d{4,}/.test(this.mcnInfo.qq)) {
                this.$alert('请输入正确的MCN QQ号');
                return false;
            }
            if (!this.mcnInfo.mobile || !/^1[34578]\d{9}$/.test(this.mcnInfo.mobile)) {
                this.$alert('请输入正确的手机号');
                return false;
            }
            if (!this.mcnInfo.credentialAttach) {
                this.$alert("请上传MCN资质证明材料");
                return false;
            }
            return true;
        },
        async getUserInfo() {
            let res = await UserApplyInfo();
            if (res.status == 200 && res.data.code == 0) {
                this.mcnInfo.qq = res.data.data.qq;
                this.userInfo = {
                    realUserName: res.data.data.realUserName,
                    identityCard: res.data.data.identityCard,
                    verifyResult: res.data.data.verifyResult,
                    authorType: res.data.data.authorType
                }
            }
            if (![20, 30, 40].includes(this.userInfo.authorType)) {
                this.editMode = true;
            } else {
                this.editMode = false;
            }
        },
        async getMcnInfo() {
            let res = await McnUserInfo();
            if (res.status == 200 && res.data.code == 0) {
                this.mcnInfo.authorType = ''
                this.mcnInfo.name = res.data.data.name;
                this.mcnInfo.mobile = res.data.data.mobile;
                this.mcnInfo.verifyResult = res.data.data.reject_reason;
                this.mcnInfo.credentialAttach = res.data.data.mcn_certificate;
                this.mcnInfo.authorType = res.data.data.mcn_status;
                if (res.data.data.mcn_certificate) {
                    this.$nextTick(() => {
                        if (this.$refs.imgUploadFile1) this.$refs.imgUploadFile1.setPic(res.data.data.mcn_certificate);
                        if (this.$refs.imgUploadFile2) this.$refs.imgUploadFile2.setPic(res.data.data.mcn_certificate);
                    })
                }
                if (![0, 10, 20].includes(this.mcnInfo.authorType)) {
                    this.mcnEditMode = true;
                } else {
                    this.mcnEditMode = false;
                }
                this.$forceUpdate()
            }
        },
        imageUploadCompleted(res) {
            if (res.btnId == 'workPic') { // 删除注意
                this.userInfo.works = res.url;
            } else if (['identityPic1', 'identityPic2', 'identityPic3'].includes(res.btnId)) {
                if (res.btnId == 'identityPic1') {
                    this.identityAttachmentIds[0] = res.id
                }
                if (res.btnId == 'identityPic2') {
                    this.identityAttachmentIds[1] = res.id
                }
                if (res.btnId == 'identityPic3') {
                    this.identityAttachmentIds[2] = res.id
                }
            }
        },
        fileUploadCompleted(res) {
            this.mcnInfo.credentialAttach = res.url;
        },
        deletePic() {
            this.mcnInfo.credentialAttach = ''
        }
    },
}
</script>
<style lang="scss" scoped>
input[disabled] {
	background: #fff;
	opacity: 1;
}
@import "~Assets/sass/pages/v4/set/set.scss";
.as-agreement-con {
	cursor: pointer;
}
.set .account-settings .upload-photo {
	position: relative;
	margin-left: 22px;
}
.set .account-settings .up-already-upload {
	position: absolute;
	top: 50%;
	left: 50%;
	font-size: 14px;
	color: #fd7e28;
	-webkit-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	line-height: 20px;
}
.reject-reason {
	font-size: 14px;
	padding-right: 10px;
	color: red;
}
.flex {
	display: flex;
	align-items: center;
}
.tgl-color {
	color: #fd7e28;
	font-size: 14px;
}
.mcn-icon {
	font-size: 14px;
	margin: 0 5px 0 15px;
}
.mcn-reject {
	color: #f56c6c;
	margin-left: 10px;
}
.mcn-required {
	position: relative;
	&::after {
		position: absolute;
		content: "*";
		color: red;
		left: -8px;
		top: -2px;
	}
}
.file-img {
	width: 215px;
	height: 115px;
}
.as-list-con {
	font-size: 14px;
	color: #333;
}
</style>
